// extracted by mini-css-extract-plugin
module.exports = {"screen-saver-container":"ScreenSaver-ScreenSaver-screen-saver-container-2hmwdQv2","screenSaverContainer":"ScreenSaver-ScreenSaver-screen-saver-container-2hmwdQv2"};